import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-errors-page',
  templateUrl: './errors-page.component.html',
  styleUrls: ['./errors-page.component.scss']
})
export class ErrorsPageComponent implements OnInit {
  urlError: string;
  error: string;

  constructor(private router: Router, protected readonly translate: TranslateService) { }

  public ngOnInit(): void {
   console.log(this.translate.currentLang)
    this.translate.getBrowserCultureLang();
  }

}



